<template>
    <div class="col-12 mx-auto">
        <div v-if="eventId && !details">
            <div class="loader" v-if="loading"></div>
            <div v-else>
                <RankingCriteriaEditCard v-model="model"
                                         v-if="true"
                                         :createNew="false"
                                         :readonly="true"
                                         :showBtns="false">
                </RankingCriteriaEditCard>
            </div>
        </div>
    </div>
</template>

<script>
    import service from "../../../services/rankingCriteria.service";
    import {RankingCriteria} from '../../../models/models';
    import {EventClaims} from '../../../models/enums';
    import RankingCriteriaEditCard from '../../../components/rankingCriteria/RankingCriteriaEditCard';
    import {mapGetters} from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            eventId: {
                type: Number,
            },
            details: {
                type: Boolean,
                default: false
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            }
        },
        components: {
            RankingCriteriaEditCard,
        },
        data() {
            return {
                loading: false,
                saving: false,
                showSelector: false,
                model: new RankingCriteria(),
                showPopup: false
            }
        },
        methods: {
            loadRankingCriteria() {
                this.loading = true;
                service
                    .getForEventId(this.eventId)
                    .then(response => {
                        if (response.data) {
                            this.model = new RankingCriteria(response.data);
                        } else {
                            this.model = new RankingCriteria();
                        }
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    }).then(() => {
                    this.loading = false;
                });
            },

        },
        haveClaimReadRights(claim) {
            if (!claim) {
                return false;
            }

            if (claim.read || claim.create || claim.update || claim.delete) {
                return true;
            }

            return false;
        },
        mounted() {
            this.loadRankingCriteria();
        },
        computed: {
            ...mapGetters(['isEnVersion', 'currentRegister', 'eventClaims']),
            canReadRankingCriteria() {
                const claim = this.$store.getters.eventClaims[EventClaims.RankingCriteria];
                const canRead = this.haveClaimReadRights(claim);
                return canRead;
            },
        }
    }
</script>
